import { Box, styled } from "@mui/material";

export function DepositText({ selectedWallet }) {
  return (
    <BoxResult>
      <Box
        dangerouslySetInnerHTML={{
          __html: selectedWallet?.address,
        }}
      />
    </BoxResult>
  );
}

const BoxResult = styled(Box)(({ theme }) => ({
  direction: "rtl",
  textAlign: "right",
  color: theme.palette.text.main,
  fontSize: "15px",

  a: {
    color: theme.palette.secondary.main,
    textDecoration: "none",
  },
}));
export default DepositText;
